import type { TEmailCaptureElement } from '@shared/dream-components';
import { EmailCaptureElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

interface Props {
  node: TEmailCaptureElement;
  children: ReactNode | ReactNode[];
}

const EmailCapture = ({ node, children }: Props) => {
  return (
    <EmailCaptureElement element={node} isLive>
      {children}
    </EmailCaptureElement>
  );
};

export default EmailCapture;
